import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { AgentToggleStub } from "./AgentToggleStub";
import { BellMenu } from "./BellMenu";
import { UserMenu } from "./UserMenu";
import { Breadcrumb } from "./Breadcrumb";
import { BrandLockup } from "@/components/brand/BrandLockup";
import { useUiPrefs } from "@/store/uiPrefs";
import { PHONE_QUERY, useIsNarrowViewport } from "@/hooks/useIsNarrowViewport";

export function TopBar(): React.ReactElement {
  const { t } = useTranslation();
  const savedCollapsed = useUiPrefs((s) => s.sidebarCollapsed);
  const collapsed = useIsNarrowViewport(PHONE_QUERY) || savedCollapsed;
  return (
    <header
      data-testid="topbar"
      className="border-border flex h-14 items-center border-b bg-[var(--bg-panel-0)]"
    >
      {/* Логотип — в ячейке шириной с LeftRail (min-w-56/min-w-14 по
          sidebarCollapsed), чтобы крошки начинались за правой границей рейла, а
          не над колонкой меню (задача 100 §2.1). `min-w` (а не `w`): в свёрнутом
          рейле вордмарк «Gudwin» шире 56px — ячейка обнимает логотип, не режет
          его. Ширины держим синхронно с `LeftRail` (w-[224px]/w-[56px]). */}
      <div
        className={[
          "flex h-full shrink-0 items-center px-4",
          collapsed ? "min-w-[56px]" : "min-w-[224px]",
        ].join(" ")}
      >
        <Link
          to="/home"
          aria-label={t("nav.home")}
          className="shrink-0 rounded-[var(--radius-1,2px)] focus-visible:ring-2 focus-visible:ring-[color:var(--accent-agent)] focus-visible:ring-offset-2 focus-visible:outline-none"
        >
          <BrandLockup size={20} />
        </Link>
      </div>
      {/* Зона контента: крошки слева (выровнены с `<main>` p-6 → pl-6), действия
          справа. Начинается за границей рейла. */}
      <div className="flex min-w-0 flex-1 items-center justify-between gap-4 pr-4 pl-6">
        <Breadcrumb />
        <div className="flex shrink-0 items-center gap-3">
          <BellMenu />
          <AgentToggleStub />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
